import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
export default{
  install (Vue, options) {
    Vue.prototype.getPdf = function (pdfDom, pdfName, imgType) {
      var title = pdfName
      var dom = document.querySelector('#pdf')
      let height = dom.style.height
      let width = dom.style.width
      var canvas = document.createElement('canvas') // 创建一个canvas节点
      var scale = 1.5 // 定义任意放大倍数 支持小数
      canvas.width = width * scale // 定义canvas 宽度 * 缩放
      canvas.height = height * scale // 定义canvas高度 *缩放
      canvas.getContext('2d').scale(scale, scale) // 获取context,设置scale
      window.d = dom
      html2Canvas(dom, {
        useCORS: true,
        height: height, // canvas 窗口的高度
        width: width,
        canvas: canvas, // 自定义 canvas
        windowHeight: height, // 获取y方向滚动条中的内容
        // dpi: window.devicePixelRatio * 1.5,
        scale: scale
      }).then(function (canvas) {
        let context = canvas.getContext('2d')
        // 关闭抗锯齿 提高清晰度
        context.mozImageSmoothingEnabled = false
        context.webkitImageSmoothingEnabled = false
        context.msImageSmoothingEnabled = false
        context.imageSmoothingEnabled = false

        let contentWidth = canvas.width
        let contentHeight = canvas.height
        let pageHeight = contentWidth / 592.28 * 841.89
        let leftHeight = contentHeight
        let position = 0
        let imgWidth = 595.28
        let imgHeight = 592.28 / contentWidth * contentHeight
        let pageData = canvas.toDataURL()
        // console.log(pageData)
        let PDF = new JsPDF('', 'pt', 'a4')
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
            leftHeight -= pageHeight
            position -= 841.89
            if (leftHeight > 0) {
              PDF.addPage()
            }
          }
        }
        PDF.save(title + '.pdf')
      }
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/Html2Pdf.js